/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'company-hub.section-extension.config-panel.background-color-field.background-color': '背景色',
  'company-hub.section-extension.config-panel.content-width-field.full-label': '全幅',
  'company-hub.section-extension.config-panel.content-width-field.full-tooltip': '全幅',
  'company-hub.section-extension.config-panel.content-width-field.label': 'コンテンツの幅',
  'company-hub.section-extension.config-panel.content-width-field.narrow-label': '狭い',
  'company-hub.section-extension.config-panel.content-width-field.narrow-tooltip': '狭い',
  'company-hub.section-extension.config-panel.content-width-field.wide-label': '広い',
  'company-hub.section-extension.config-panel.content-width-field.wide-tooltip': '広い',
  'company-hub.section-extension.config-panel.preamble':
    '要素をカスタマイズ可能なセクションで分けて整理します。{supportLink}',
  'company-hub.section-extension.config-panel.preamble-link.label': 'ハブのデザインに関する詳細をご確認ください。',
  'company-hub.section-extension.config-panel.preamble-without-support-link':
    'カスタマイズ可能な背景とスタイルを使用して、関連する要素をセクションで分けて整理します。',
  'company-hub.section-extension.config-panel.title': 'セクション',
  'company-hub.section-extension.error-loading-content': 'コンテンツの読み込み中にエラーが発生しました',
  'company-hub.section-extension.manifest.content.header': 'セクションにタイトルを付ける',
  'company-hub.section-extension.manifest.content.placeholder-title': 'プレースホルダー',
  'company-hub.section-extension.manifest.content.sub-header':
    'カスタマイズ可能な背景を使用して、要素をセクション別に整理します。',
  'company-hub.section-extension.manifest.extension-lozenge-title': 'セクション',
  'company-hub.section-extension.manifest.extension-title': 'セクション [New]',
  'company-hub.section-extension.manifest.macro-description': '背景を使用して要素をグループ化',
};
